import { useQuery } from "@apollo/client";

import { runnerShiftsQuery } from "../shifts/queries";

export default function usePickupCapacitySettings(installationId) {
  const { data, loading, error } = useQuery(runnerShiftsQuery, {
    variables: { installationId, includeInactive: false },
    skip: !installationId,
    fetchPolicy: "cache-and-network",
  });

  return {
    shifts: (data?.runnerShifts ?? []).filter((shift) => shift?.isActive !== false),
    loading,
    error,
  };
}
